"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _Headlight = _interopRequireDefault(require("./Headlight.js"));
var _SurveyModalContents = _interopRequireDefault(require("../ModalContents/SurveyModalContents.js"));
var _FlowModalContents = _interopRequireDefault(require("../ModalContents/FlowModalContents.js"));
var _JsonEditorModalContents = _interopRequireDefault(require("../ModalContents/JsonEditorModalContents.js"));
var _styleSurveycard = _interopRequireDefault(require("./style-surveycard.css"));
var _eye = _interopRequireDefault(require("cccisd-icons/eye"));
var _wrench = _interopRequireDefault(require("cccisd-icons/wrench"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil5"));
var _boxAdd = _interopRequireDefault(require("cccisd-icons/box-add"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _boxRemove = _interopRequireDefault(require("cccisd-icons/box-remove"));
var _broom = _interopRequireDefault(require("cccisd-icons/broom"));
var _arrowResize = _interopRequireDefault(require("cccisd-icons/svg/arrow-resize4"));
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
var _admin = require("../../reducers/admin.js");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _HighlightWord = _interopRequireDefault(require("../HighlightWord"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _composeErrorMessage = _interopRequireDefault(require("../../helpers/composeErrorMessage.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var Fortress = window.cccisd && window.cccisd.fortress;
var SurveyCard = /*#__PURE__*/function (_React$Component) {
  _inherits(SurveyCard, _React$Component);
  var _super = _createSuper(SurveyCard);
  function SurveyCard() {
    var _this;
    _classCallCheck(this, SurveyCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: false
    });
    _defineProperty(_assertThisInitialized(_this), "archiveSurvey", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var surveyData, isSuccess;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              surveyData = _this.props.surveyData;
              _this.setState({
                loading: true
              });
              _context.next = 4;
              return _this.props.archiveSurvey(surveyData.surveyId);
            case 4:
              isSuccess = _context.sent;
              if (isSuccess) {
                (0, _cccisdNotification["default"])('Survey successfully archived');
              } else {
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: 'Survey failed to archive'
                });
                _this.setState({
                  loading: false
                });
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "unarchiveSurvey", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var surveyData, isSuccess;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              surveyData = _this.props.surveyData;
              _this.setState({
                loading: true
              });
              _context2.next = 4;
              return _this.props.unarchiveSurvey(surveyData.surveyId);
            case 4:
              isSuccess = _context2.sent;
              if (isSuccess) {
                (0, _cccisdNotification["default"])('Survey successfully unarchived');
              } else {
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: 'Survey failed to unarchive'
                });
                _this.setState({
                  loading: false
                });
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    _defineProperty(_assertThisInitialized(_this), "deleteSurvey", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(surveyToDeleteId) {
        var surveyData, isSuccess;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                surveyData = _this.props.surveyData;
                _this.setState({
                  loading: true
                });
                _context3.next = 4;
                return _this.props.deleteSurvey(surveyData.surveyId);
              case 4:
                isSuccess = _context3.sent;
                if (isSuccess) {
                  (0, _cccisdNotification["default"])('Survey successfully deleted');
                } else {
                  (0, _cccisdNotification["default"])({
                    type: 'danger',
                    message: 'Survey failed to delete'
                  });
                  _this.setState({
                    loading: false
                  });
                }
              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "onUpdateSurvey", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(values) {
        var surveyId, isSuccess;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                surveyId = _this.props.surveyData.surveyId;
                _context4.prev = 1;
                _context4.next = 4;
                return _this.props.updateSurvey(surveyId, _objectSpread(_objectSpread({}, _this.props.surveyData.settings), values));
              case 4:
                isSuccess = _context4.sent;
                if (isSuccess) {
                  (0, _cccisdNotification["default"])("Survey \"".concat(values.title, "\" successfully updated"));
                } else {
                  (0, _cccisdNotification["default"])({
                    type: 'danger',
                    message: 'Survey failed to update'
                  });
                }
                _context4.next = 11;
                break;
              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](1);
                return _context4.abrupt("return", Promise.reject(_context4.t0));
              case 11:
                _this.editSurveyModal.close();
              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 8]]);
      }));
      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "_renderHeadlight", function () {
      var _this$props = _this.props,
        assignmentTerm = _this$props.assignmentTerm,
        assignment = _this$props.assignment,
        project = _this$props.project,
        surveyData = _this$props.surveyData;

      // archived survey headlight
      if (!surveyData.archived) {
        // display text to identify assignment and project names
        var assignmentProjectStr = "For Survey \"".concat(surveyData.label, "\", ").concat(assignmentTerm, " \"").concat(assignment.label, "\"");
        if (project.label !== '') {
          assignmentProjectStr += ' in Quest Project "' + project.label + '"';
        }

        // normal headlight
        return /*#__PURE__*/_react["default"].createElement(_Headlight["default"], null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: "Edit Survey"
          }, /*#__PURE__*/_react["default"].createElement("a", {
            "data-edit-survey-button": surveyData.surveyId,
            className: "btn btn-xs btn-success"
          }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null))),
          title: "Edit Survey",
          ref: function ref(elem) {
            _this.editSurveyModal = elem;
          }
        }, /*#__PURE__*/_react["default"].createElement(_SurveyModalContents["default"], {
          assignmentProjectStr: assignmentProjectStr,
          initialValues: {
            title: surveyData.label,
            subtitle: surveyData.description,
            isRequired: 'isRequired' in surveyData.settings ? surveyData.settings.isRequired : true
          },
          onSubmit: _this.onUpdateSurvey
        })), (Fortress.user.acting.user.auth_type === 'ldap' || !!Fortress.user.acting.is_super_user) && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: "Settings JSON Editor"
          }, /*#__PURE__*/_react["default"].createElement("a", {
            "data-edit-json-button": surveyData.surveyId,
            className: "btn btn-xs btn-warning"
          }, /*#__PURE__*/_react["default"].createElement(_broom["default"], null))),
          title: "Settings JSON Editor",
          size: "large"
        }, /*#__PURE__*/_react["default"].createElement(_JsonEditorModalContents["default"], {
          assignmentProjectStr: assignmentProjectStr,
          surveyData: surveyData
        })), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Archive"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn btn-xs btn-primary",
          "data-archive-survey-button": surveyData.surveyId,
          onClick: function onClick() {
            (0, _cccisdConfirm["default"])({
              message: 'Confirm archive?',
              description: "Are you sure you want to archive Survey '" + surveyData.label + "'?",
              confirmLabel: 'Yes',
              abortLabel: 'Cancel'
            }).then(_this.archiveSurvey);
          }
        }, /*#__PURE__*/_react["default"].createElement(_boxAdd["default"], null)))), /*#__PURE__*/_react["default"].createElement("span", null, _this._renderDeleteActionButton()));
      }
      return /*#__PURE__*/_react["default"].createElement(_Headlight["default"], null, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Unarchive"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-xs btn-info",
        "data-unarchive-survey-button": surveyData.surveyId,
        onClick: _this.unarchiveSurvey
      }, /*#__PURE__*/_react["default"].createElement(_boxRemove["default"], null))), _this._renderDeleteActionButton());
    });
    _defineProperty(_assertThisInitialized(_this), "_renderDeleteActionButton", function (data) {
      var surveyData = _this.props.surveyData;
      return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Delete"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-xs btn-danger",
        "data-delete-survey-button": surveyData.surveyId,
        onClick: function onClick() {
          (0, _cccisdConfirm["default"])({
            message: 'Confirm delete?',
            description: "Are you sure you want to delete Survey '" + surveyData.label + "'?",
            confirmLabel: 'Yes',
            abortLabel: 'Cancel'
          }).then(_this.deleteSurvey);
        }
      }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderSurveyList", function () {
      var _this$props2 = _this.props,
        assignment = _this$props2.assignment,
        surveyData = _this$props2.surveyData;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _map2["default"])(assignment.settings.languages, function (lang, key) {
        // find the flow that matches the language (if it exists)
        var flowItemData = (0, _find2["default"])(surveyData.flowList, function (flowItem) {
          if (flowItem.language) {
            return flowItem.language.toUpperCase() === lang.toUpperCase();
          }
        });

        // create the row based on the flow's information
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _styleSurveycard["default"].languageRow,
          key: key
        }, _this._renderLanguageRow(lang, flowItemData));
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderLanguageRow", function (language, flowData) {
      var assignment = _this.props.assignment;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleSurveycard["default"].editArea
      }, _this._renderSurveyButton(language, flowData)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleSurveycard["default"].previewArea
      }, flowData && assignment.settings && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        title: "Preview survey",
        size: "large",
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-default btn-sm"
        }, /*#__PURE__*/_react["default"].createElement(_eye["default"], {
          spaceRight: true
        }), "Preview")
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.Player, {
        flowId: flowData.flowId,
        isPreviewMode: true,
        onComplete: function onComplete() {}
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleSurveycard["default"].dateArea
      }, flowData && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Last modified:", /*#__PURE__*/_react["default"].createElement("br", null), flowData.updatedAt || '—')));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderSurveyButton", function (languageCode, flowData) {
      var _this$props3 = _this.props,
        assignment = _this$props3.assignment,
        project = _this$props3.project;

      // get text/display version of language name
      var langDisplay = '';
      if (assignment.settings.languages.length > 1 && languageCode !== '') {
        langDisplay = ' ' + _this.getLanguageNameFromTwoLetterCode(languageCode) + ' Version';
      }
      // if flow exists
      if (flowData) {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
          className: "btn btn-sm btn-success",
          to: "/quest/".concat(project.groupId, "/design/flow/").concat(flowData.flowId)
        }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], {
          spaceRight: true
        }), "Edit", langDisplay);
      }

      // if flow does not exist and is not archived
      return _this._renderCreateFlowModal(languageCode, langDisplay);
    });
    _defineProperty(_assertThisInitialized(_this), "onCreateFlow", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(languageCode, values) {
        var _this$props4, surveyData, history, project, data, formData, isSuccess, response, flowId;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this$props4 = _this.props, surveyData = _this$props4.surveyData, history = _this$props4.history, project = _this$props4.project;
                data = {
                  name: surveyData.label,
                  language: languageCode,
                  type: 'survey',
                  handle: surveyData.surveyHandle,
                  settings: {
                    showOneElementPerPage: false,
                    showRequiredState: false,
                    showQuestionNumbers: false,
                    playerTemplate: 'default',
                    playerTemplateSettings: {}
                  }
                };
                _context5.t0 = values.createFlow;
                _context5.next = _context5.t0 === 'startWith' ? 5 : _context5.t0 === 'existing' ? 7 : _context5.t0 === 'fromFile' ? 9 : 14;
                break;
              case 5:
                if (values.startWith !== 'none') {
                  data.example = values.startWith;
                }
                return _context5.abrupt("break", 15);
              case 7:
                data.existing = values.copyFlowId;
                return _context5.abrupt("break", 15);
              case 9:
                formData = new FormData();
                Object.keys(data).forEach(function (key) {
                  formData.append(key, data[key]);
                });
                formData.append('file', values.file);
                data = formData;
                return _context5.abrupt("break", 15);
              case 14:
                throw new Error("Unknown option \"".concat(values.createFlow, "\""));
              case 15:
                _context5.prev = 15;
                _context5.next = 18;
                return _this.props.createFlow(data);
              case 18:
                isSuccess = _context5.sent;
                if (!isSuccess) {
                  _context5.next = 28;
                  break;
                }
                _context5.next = 22;
                return _cccisdAxios["default"].get(Boilerplate.route('flow.handle.id', {
                  handle: surveyData.surveyHandle,
                  language: languageCode
                }));
              case 22:
                response = _context5.sent;
                flowId = response.data.flowId;
                (0, _cccisdNotification["default"])("Survey \"".concat(surveyData.label, "\" successfully created"));
                history.push("/quest/".concat(project.groupId, "/design/flow/").concat(flowId));
                _context5.next = 29;
                break;
              case 28:
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: "Survey \"".concat(surveyData.label, "\" failed to create")
                });
              case 29:
                _context5.next = 35;
                break;
              case 31:
                _context5.prev = 31;
                _context5.t1 = _context5["catch"](15);
                (0, _cccisdNotification["default"])({
                  type: 'danger',
                  message: (0, _composeErrorMessage["default"])(_context5.t1),
                  duration: 0
                });
                return _context5.abrupt("return", Promise.reject(_context5.t1));
              case 35:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[15, 31]]);
      }));
      return function (_x3, _x4) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "_renderCreateFlowModal", function (languageCode, langDisplay) {
      var _this$props5 = _this.props,
        project = _this$props5.project,
        assignment = _this$props5.assignment,
        assignmentTerm = _this$props5.assignmentTerm,
        surveyData = _this$props5.surveyData;

      // display text to identify flow language, assignment term, and project name
      var langDisplayVersion = assignment.settings.languages.length > 1 ? _this.getLanguageNameFromTwoLetterCode(languageCode) : '';
      var assignmentProjectLanguageStr = 'For the ' + langDisplayVersion + " version in Survey '" + surveyData.label + "'";
      if (assignment.label !== '') {
        assignmentProjectLanguageStr += ' in ' + assignmentTerm + " '" + assignment.label + "'";
      }
      if (project.label !== '') {
        assignmentProjectLanguageStr += " in Quest Project '" + project.label + "'";
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-primary btn-sm",
          type: "button"
        }, /*#__PURE__*/_react["default"].createElement(_wrench["default"], {
          spaceRight: true
        }), "Create", langDisplay),
        title: "Create the \"".concat(surveyData.label, "\" Survey").concat(langDisplayVersion && " (".concat(langDisplayVersion, ")"))
      }, /*#__PURE__*/_react["default"].createElement(_FlowModalContents["default"], {
        assignmentProjectLanguageStr: assignmentProjectLanguageStr,
        onSubmit: function onSubmit(values) {
          return _this.onCreateFlow(languageCode, values);
        }
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "getLanguageNameFromTwoLetterCode", function (code) {
      switch (code.toUpperCase()) {
        case 'EN':
          return 'English';
        case 'ES':
          return 'Spanish';
        default:
          return '';
      }
    });
    return _this;
  }
  _createClass(SurveyCard, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props6 = this.props,
        isAssignmentArchived = _this$props6.isAssignmentArchived,
        surveyData = _this$props6.surveyData,
        index = _this$props6.index,
        isDragDisabled = _this$props6.isDragDisabled,
        designFilter = _this$props6.designFilter;
      var isArchived = isAssignmentArchived || surveyData.archived;
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.state.loading
      }, isArchived ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleSurveycard["default"].cardWrapper,
        "data-survey-card": surveyData.surveyId
      }, !isAssignmentArchived && this._renderHeadlight(), /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleSurveycard["default"].contentWrapper + ' ' + _styleSurveycard["default"].archived
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleSurveycard["default"].leftSide
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleSurveycard["default"].title
      }, surveyData.label), surveyData.description && /*#__PURE__*/_react["default"].createElement("div", {
        className: _styleSurveycard["default"].description
      }, surveyData.description)))) : /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
        draggableId: "".concat(surveyData.surveyId),
        index: index,
        isDragDisabled: isDragDisabled
      }, function (provided, snapshot) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          ref: provided.innerRef
        }, provided.draggableProps, {
          className: _styleSurveycard["default"].cardWrapper,
          "data-survey-card": surveyData.surveyId
        }), _this2._renderHeadlight(), /*#__PURE__*/_react["default"].createElement("div", {
          className: _styleSurveycard["default"].contentWrapper
        }, /*#__PURE__*/_react["default"].createElement("div", _extends({
          className: (0, _classnames2["default"])(_styleSurveycard["default"].dragHandle, _defineProperty({}, _styleSurveycard["default"].disabled, isDragDisabled)),
          "data-survey-card-draggable": surveyData.surveyId
        }, provided.dragHandleProps), /*#__PURE__*/_react["default"].createElement(_arrowResize["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
          className: _styleSurveycard["default"].leftSide
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _styleSurveycard["default"].title
        }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: surveyData.label
        }, /*#__PURE__*/_react["default"].createElement(_HighlightWord["default"], {
          string: surveyData.label,
          word: designFilter
        }))), surveyData.description && /*#__PURE__*/_react["default"].createElement("div", {
          className: _styleSurveycard["default"].description
        }, /*#__PURE__*/_react["default"].createElement(_HighlightWord["default"], {
          string: surveyData.description,
          word: designFilter
        }))), /*#__PURE__*/_react["default"].createElement("div", {
          className: _styleSurveycard["default"].divider
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _styleSurveycard["default"].rightSide
        }, _this2._renderSurveyList())));
      }));
    }
  }]);
  return SurveyCard;
}(_react["default"].Component);
_defineProperty(SurveyCard, "propTypes", {
  index: _propTypes["default"].number,
  project: _propTypes["default"].object,
  assignmentTerm: _propTypes["default"].string,
  assignment: _propTypes["default"].object.isRequired,
  surveyData: _propTypes["default"].object.isRequired,
  isAssignmentArchived: _propTypes["default"].bool,
  updateSurvey: _propTypes["default"].func,
  archiveSurvey: _propTypes["default"].func,
  unarchiveSurvey: _propTypes["default"].func,
  deleteSurvey: _propTypes["default"].func,
  createFlow: _propTypes["default"].func,
  isDragDisabled: _propTypes["default"].bool,
  designFilter: _propTypes["default"].string,
  history: _propTypes["default"].object
});
_defineProperty(SurveyCard, "defaultProps", {
  assignmentTerm: 'Assignment'
});
var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(null, {
  updateSurvey: _admin.updateSurvey,
  createFlow: _admin.createFlow,
  archiveSurvey: _admin.archiveSurvey,
  unarchiveSurvey: _admin.unarchiveSurvey,
  deleteSurvey: _admin.deleteSurvey
})(SurveyCard));
exports["default"] = _default;